export default "__VITE_ASSET__BFk7RTgi__"